import Vue from 'vue'
// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css' // Vuesax

Vue.use(Vuesax)
